import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import ProblemSolution from '../components/ProblemSolution';
import Services from '../components/Services';
import AIFeature from '../components/AIFeature';
import Results from '../components/Results';
import HowItWorks from '../components/HowItWorks';
import Portfolio from '../components/Portfolio';
import CTASection from '../components/CTASection';

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Synex Agency – AI-Powered Websites & Automation for Home Service Businesses</title>
        <meta name="description" content="We build high-converting websites and AI automation systems for US-based home service, med spa, and dental businesses. Get more leads, faster response, less manual work." />
        <meta name="keywords" content="AI automation, web design, home service websites, lead generation, AI chatbot, med spa marketing, dental marketing, roofing leads, HVAC marketing" />
        <meta property="og:title" content="Synex Agency – AI-Powered Websites & Automation for Home Service Businesses" />
        <meta property="og:description" content="We build high-converting websites and AI automation systems for US-based home service, med spa, and dental businesses." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://synex.agency" />
        <meta property="og:image" content="https://synex.agency/assets/synex.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Synex Agency – AI-Powered Websites & Automation" />
        <meta name="twitter:description" content="More leads, faster response, less manual work for US-based home service businesses." />
        <meta name="twitter:image" content="https://synex.agency/assets/synex.png" />
        <link rel="canonical" href="https://synex.agency" />
      </Helmet>
      <Hero />
      <ProblemSolution />
      <Services />
      <AIFeature />
      <Results />
      <HowItWorks />
      <Portfolio />
      <CTASection />
    </>
  );
}

